// Import Angular stuff

import { Injectable } from '@angular/core';

// Import RxJS stuff

import { Observable } from 'rxjs';
import { Subject } from 'rxjs';

// Import services used by EnvironmentService

export enum Environment {
  CI = 'CI',
  DEV = 'DEV',
  INTTEST = 'INTTEST',
  INTEGRATION = 'INTEGRATION',
  PREEXTTEST = 'PREEXTTEST',
  PREPROD = 'PREPROD',
  P3EXT = 'P3EXT' ,
  EXTTEST = 'EXTTEST',
  PROD = 'PROD',
}

const landingUrls: Map<Environment, string> = new Map([
  [Environment.DEV, 'https://www-ibmdev.serviceplatformen.dk/administration/'],
  [
    Environment.INTTEST,
    'https://www-ibminttest.serviceplatformen.dk/administration/',
  ],
  [
    Environment.INTEGRATION,
    'https://www-ibmintegration.serviceplatformen.dk/administration/',
  ],
  [
    Environment.PREEXTTEST,
    'https://www-ibmpreexttest.serviceplatformen.dk/administration/',
  ],
  [
    Environment.PREPROD,
    'https://www-ibmpreprod.serviceplatformen.dk/administration/',
  ],
  [
Environment.P3EXT,
    'https://www-ext-tp3.serviceplatformen.dk/administration/',
  ], 
  [
    Environment.EXTTEST,
    'https://exttestwww.serviceplatformen.dk/administration/',
  ],
  [Environment.PROD, 'https://www.serviceplatformen.dk/administration/'],
  
]);

let browserUrl: string = window.location.href;
if(window.location.port == null || window.location.port == '')
{
  browserUrl = window.location.protocol+'//'+window.location.hostname+'/access';
}
else
{
  browserUrl = window.location.protocol+'//'+window.location.hostname+':'+window.location.port+'/access';
}

const authUrls: Map<Environment, string> = new Map([
  [Environment.DEV, browserUrl],
  [
    Environment.INTTEST,
    browserUrl,
  ],
  [
    Environment.INTEGRATION,
    browserUrl,
  ],
  [
    Environment.PREEXTTEST,
    browserUrl,
  ],
  [
    Environment.PREPROD,
    browserUrl,
  ],
  [
    Environment.P3EXT,
    browserUrl,
  ],
  [
    Environment.CI,
    browserUrl
  ],
  [Environment.EXTTEST, browserUrl],
  [Environment.PROD, browserUrl],
]);

@Injectable()
export class EnvironmentService {
  private _environment: Subject<Environment> = new Subject<Environment>();
  private authURL: string;

  public getAuthURL = (): string => {
    let authUrlString = authUrls.get(this.getEnvironment())!;
    return authUrlString;
  };

  public getLandingURL = (): string => {
    let landingUrlString = landingUrls.get(this.getEnvironment())!;
    return landingUrlString;
  };

  /**
   *
   * @param {SessionStorageService} storageService
   */

  constructor() {
    this.authURL = this.getLandingURL();
  }

  /**
   *
   * @returns {Observable<any>}
   */

  public get environment(): Observable<Environment> {
    return this._environment;
  }

  /**
   *
   * @returns {Environment}
   */

  public getEnvironment = (): Environment => {
    let url: string = window.location.href;

    if (url.includes('ibmdev')) {
      return Environment.DEV;
    } else if (url.includes('ibmpreprod')) {
      return Environment.PREPROD;
    } else if (url.includes('ibmpreexttest')) {
      return Environment.PREEXTTEST;
    } else if (url.includes('ibmintegration')) {
      return Environment.INTEGRATION;
    } else if (url.includes('ibminttest')) {
      return Environment.INTTEST;
    } else if (url.includes('ext-tp3')) {
      return Environment.P3EXT;
    } else if (url.includes('exttestwww')) {
      return Environment.EXTTEST;
    } else if (url.includes('https://www.serviceplatformen.dk')) {
      return Environment.PROD;
    } else {
      return Environment.CI;
    }
  };

  /**
   *
   * @param {Environment} environment
   */

  public setEnvironment = (environment: Environment): void => {
    // this.storageService.put('environment', environment);

    this._environment.next(environment);
  };
}
